import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MarketService } from "../../../../../shared/src/lib/services/market.service";
import { Router, RouterLink } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { debounceTime, distinctUntilChanged, filter, Observable, Subject, switchMap } from "rxjs";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SearchService } from "../../pages/search-results/search.service";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "../../../../../shared/src/lib/services/loader.service";
import { MatDividerModule } from "@angular/material/divider";
import { NavService } from "../../../../../shared/src/lib/services/nav.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-search",
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    RouterLink,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
    DatePipe,
    MatDividerModule,
  ],
  templateUrl: "./search.component.html",
  styleUrl: "./search.component.scss",
})
export class SearchComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  loader = inject(LoaderService);
  marketService = inject(MarketService);
  router = inject(Router);
  searchService = inject(SearchService);
  navService = inject(NavService);
  searchControl = new FormControl("");
  searchResults: any = [];
  page = 1;
  size = 10;

  constructor() {}

  ngOnInit() {
    this.handleSearchChange();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleSearchChange() {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(1000),
        filter((value: any) => value?.length >= 3 || value?.length === 0),
        distinctUntilChanged(),
        switchMap((value) => this.getSearchResult({ keyword: value })),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        // console.log(result);
        this.searchResults = result;
      });
  }

  onSearch() {
    this.router.navigate(["/app/search-data", this.page, this.size, this.searchControl.value]);
  }

  getSearchResult(params?: any): Observable<any> {
    const qParams = {
      ...params,
      page: this.page,
      size: this.size,
    };

    return new Observable((observer) => {
      this.marketService
        .searchItems(qParams)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response: any) => {
            // console.log(response);
            if (response?.data) {
              // this.searchResults = response?.data?.content;
              observer.next(response?.data?.content);
            } else {
              observer.next([]);
            }

            observer.complete();
          },
          error: (error: any) => {
            console.error(error);

            observer.error(error);
          },
        });
    });
  }
}
